import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pagination--previous",
  "use": "icon-pagination--previous-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 26\" id=\"icon-pagination--previous\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m11.383 12.231 3.45 3.224-.636.776-3.866-3.611a.532.532 0 0 1-.165-.389c0-.148.06-.29.165-.388l3.866-3.612.636.777-3.45 3.223Z\" fill=\"#D1D3D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol